import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { StoreCodeCellLocalStoreService } from './store-code-cell-local-store.service';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { LetDirective } from '@ngrx/component';
import { LocationListService } from '../../../location-list/location-list.service';

@Component({
  selector: 'app-store-code-cell',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    LetDirective,
  ],
  templateUrl: './store-code-cell.component.html',
  styleUrl: './store-code-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StoreCodeCellLocalStoreService]
})
export class StoreCodeCellComponent extends AgCellRendererComponent {
  value$ = this.localStore.cellValue$;

  constructor(protected localStore: StoreCodeCellLocalStoreService,
              private locationListService: LocationListService) {
    super(localStore);
  }

  /**
   * @param payload String that should be copied to clipboard
   */
  copyToClipboard(payload: string) {
    this.locationListService.copyStringToClipboard(payload);
  }

}
